module.exports = __webpack_public_path__ + "assets/img/19-m.bd42b87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/19-m.jpg
// module id = 7z5+
// module chunks = 0